module.exports = __webpack_public_path__ + "static/media/MItheater1.f1fd0de2.jpg";